import {Loader} from '@mantine/core'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {useEffect} from 'react'

import {getStoredUser} from 'src/lib/auth'

export const Route = createFileRoute('/_authed/')({
    component: IndexRedirect,
})

function IndexRedirect() {
    const user = getStoredUser()!
    const navigate = useNavigate()

    useEffect(() => {
        if (user.is_admin) {
            navigate({to: '/admin', replace: true})
        } else if (user.organization_id) {
            navigate({
                to: '/organizations/$orgId',
                params: {orgId: user.organization_id},
                replace: true,
            })
        } else {
            throw new Error('No organization or admin found. This should never happen.')
        }
    }, [user.is_admin, user.organization_id, navigate])

    return <Loader size="lg" style={{display: 'block', margin: '100px auto'}} />
}
